import {React,useEffect} from "react";

import { useSelector } from "react-redux";
import Loginpage from "./Loginpage";

import PassworCheck from "./checkTempPassword";
import Dashbord from "./dashbord";

import { BrowserRouter,useNavigate } from 'react-router-dom';

function Mainpage() {
  


  return <div>
     <Dashbord /></div>;
}
export default Mainpage;
